import { List } from 'immutable';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Snackbar } from '@material-ui/core';

import {
  lotteriesActions,
  getVisibleLotteries,
  getLotteryState,
  getShowAnimation,
  getDrumRollSound,
  getWinnerSound,
  getMessage,
  getIsSnackBar,
  getNumberOfWinner,
} from '../../../core/lotteries';
import LotteryList from '../../components/lottery-list';
import LotteryAnimation from './LotteryAnimation';
import LotterySounds from './LotterySounds';

const propTypes = {
  lastWinners: PropTypes.instanceOf(List).isRequired,
  pending: PropTypes.bool.isRequired,
  loadLotteries: PropTypes.func.isRequired,
  startLottery: PropTypes.func.isRequired,
  startDramRoll: PropTypes.func.isRequired,
  showAndHideSnackBar: PropTypes.func.isRequired,
  finishedWinAnimation: PropTypes.func.isRequired,
  updateNumberOfWinner: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  lotteries: PropTypes.instanceOf(List).isRequired,
  unloadLotteries: PropTypes.func.isRequired,
  numberOfWinner: PropTypes.number.isRequired,
  showAnimation: PropTypes.bool.isRequired,
  drumRollSound: PropTypes.string.isRequired,
  winnerSound: PropTypes.string.isRequired,
  isSnackBar: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

class Lottery extends Component {
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.loadLotteries();
  }

  componentWillUnmount() {
    this.props.unloadLotteries();
  }

  isSelectedNumberOfWinner(numberOfWinner) {
    return this.props.numberOfWinner === numberOfWinner
      ? 'secondary'
      : 'default';
  }

  render() {
    const {
      lotteries,
      startLottery,
      startDramRoll,
      finishedWinAnimation,
      pending,
      lastWinners,
      showAnimation,
      drumRollSound,
      winnerSound,
      showAndHideSnackBar,
      updateNumberOfWinner,
      isSnackBar,
      message,
      numberOfWinner,
    } = this.props;

    const winners = lotteries.filter(d => d.status === 'won');
    const candidates = lotteries.filter(d => d.status !== 'won');

    const doLottery = () => {
      if (candidates.size < numberOfWinner) {
        return showAndHideSnackBar(
          '抽選人数が参加人数よりも多いです。抽選人数を変更してください。',
          3000,
        );
      }

      return startDramRoll();
    };

    return (
      <div className="g-row">
        <div className="g-col" style={{ padding: '50px' }}>
          <p>抽選人数</p>
          <ul className="number_of_winner_list">
            <li>
              <Button
                variant="contained"
                color={this.isSelectedNumberOfWinner(1)}
                onClick={() => updateNumberOfWinner(1)}
              >
                1人
              </Button>
            </li>
            <li>
              <Button
                variant="contained"
                color={this.isSelectedNumberOfWinner(3)}
                onClick={() => updateNumberOfWinner(3)}
              >
                3人
              </Button>
            </li>
            <li>
              <Button
                variant="contained"
                color={this.isSelectedNumberOfWinner(5)}
                onClick={() => updateNumberOfWinner(5)}
              >
                5人
              </Button>
            </li>
          </ul>
          <Button
            variant="contained"
            color="primary"
            fullWidth={true}
            onClick={doLottery}
          >
            抽選する
          </Button>
        </div>
        <div className="g-col g-col-6">
          <p>{`${candidates.size}人の方が抽選に参加中`}</p>
          <LotteryList lotteries={candidates} />
        </div>
        <div className="g-col g-col-6">
          <p>{`${winners.size}人の方が当選`}</p>
          <LotteryList lotteries={winners} />
        </div>
        <Snackbar open={isSnackBar} message={message} />
        <LotterySounds
          drumRollSound={drumRollSound}
          winnerSound={winnerSound}
          numberOfWinner={numberOfWinner}
          finishedWinAnimation={finishedWinAnimation}
          startLottery={startLottery}
        />
        <LotteryAnimation
          showAnimation={showAnimation}
          pending={pending}
          lastWinners={lastWinners}
        />
      </div>
    );
  }
}

//= ====================================
//  CONNECT
//-------------------------------------
const mapStateToProps = state => ({
  lotteries: getVisibleLotteries(state),
  pending: getLotteryState(state.lotteries),
  lastWinners: state.lotteries.lastWinners,
  showAnimation: getShowAnimation(state.lotteries),
  drumRollSound: getDrumRollSound(state.lotteries),
  winnerSound: getWinnerSound(state.lotteries),
  isSnackBar: getIsSnackBar(state.lotteries),
  message: getMessage(state.lotteries),
  numberOfWinner: getNumberOfWinner(state.lotteries),
});

const mapDispatchToProps = Object.assign({}, lotteriesActions);

Lottery.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(Lottery);



// WEBPACK FOOTER //
// ./src/views/pages/lottery/index.js